/** Anonymous requests deliberately bypass the authenticated RTK base query and refresh flow. */
export const publicWidgetUrl = (id: string) =>
  `${import.meta.env.VITE_API_URL?.replace(/\/$/, '') ?? ''}/v2/public/widgets/${encodeURIComponent(id)}`;
export type { PublicWidget, WidgetGrant } from '@features/Workspace/widgetApi';
